import React from 'react';
import { SvgIcon } from '@mui/material';

const styles = {
  viewBoxStyle: '0 0 18 20',
  iconStyle: {
    width: 18,
    height: 20,
  },
};

class DataSourcesIcon extends React.Component {
  render() {
    return (
      <SvgIcon {...this.props} viewBox={styles.viewBoxStyle} style={styles.iconStyle}>
        <g id="Page-1" stroke="none" strokeWidth="1" fillRule="evenodd">
          <g id="Frame" transform="translate(-34.000000, -202.000000)" fillRule="nonzero">
            <g id="Data-Sources" transform="translate(34.000000, 202.000000)">
              <g id="database">
                <path
                  d="M9,0 C4.0275,0 0,1.98888889 0,4.44444444 C0,6.9 4.0275,8.88888889 9,8.88888889 C13.9725,8.88888889 18,6.9 18,4.44444444 C18,1.98888889 13.9725,0 9,0 L9,0 Z M0,6.66666667 L0,10 C0,12.4555556 4.0275,14.4444444 9,14.4444444 C13.9725,14.4444444 18,12.4555556 18,10 L18,6.66666667 C18,9.12222222 13.9725,11.1111111 9,11.1111111 C4.0275,11.1111111 0,9.12222222 0,6.66666667 L0,6.66666667 Z M0,12.2222222 L0,15.5555556 C0,18.0111111 4.0275,20 9,20 C13.9725,20 18,18.0111111 18,15.5555556 L18,12.2222222 C18,14.6777778 13.9725,16.6666667 9,16.6666667 C4.0275,16.6666667 0,14.6777778 0,12.2222222 Z"
                  id="Shape"
                />
              </g>
            </g>
          </g>
        </g>
      </SvgIcon>
    );
  }
}

export default DataSourcesIcon;
